<template>
    <div class="recommendClinicItem">
        <div class="recommendClinicPic">
            <img :src="item?.Pics?.[0]?.url?.['w0h0'] || errorPic" @error="handleImageError">
        </div>
        <div class="recommendClinicText">
            <div class="recommendClinicName">{{ item.name }}</div>
            <input type="hidden" class="type_id_specId_key" name="type_id_specId_key[]"
                   :data-type_id_specId_key="item.typeIdSpecIdKey"
                   :value="item.typeIdSpecIdKey">
            <div class="recommendClinicTagBox">
                <div class="recommendClinicTag" :key=key v-for="(tag,key) in tags">{{ tag }}</div>
            </div>
            <div class="introBox">
                <div class="recommendClinicIntro">
                    {{item.synopsisLimit}}
                </div>
                <a :href="`clinic/${item.slug}`"><div class="checkBtn">查看更多</div></a>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'ItemList',
    components: {

    },
    props: {
        item: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            errorPic: 'img/pic/no_image_icon.png',
        };
    },
    computed: {
        tags() {
            return this.item.tag ? this.item.tag.split(',') : [];
        }
    },
    beforeMount() {

    },
    mounted() {
    },
    methods: {
        formatDate(dateString) {
            const options = {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            };
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', options);
        },
        handleImageError(event) {
            // eslint-disable-next-line no-param-reassign
            event.target.src = this.errorPic;
        },
    },
};
</script>

<style scoped lang="scss">

</style>
